import React from "react";
import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const FeedbackInputs = (props) => {

    const {
        modeList,
        typeList,
        formData,
        setFormValue,
    } = props;

    return (
        <Grid container spacing={2}>
            <Grid container item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                    <InputLabel required id={`label-type`}>{getLocalizedString("purpose")}</InputLabel>
                    <Select
                        value={formData.type}
                        labelId={`label-type`}
                        id={`select-type`}
                        onChange={(e) => setFormValue(e.target.value, "type")}
                        margin={"none"}
                    >
                        {
                            typeList?.map(item => (
                                <MenuItem
                                    className={"whiteText"}
                                    key={item.key}
                                    value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
            <Grid container item xs={12} sm={6} md={4}>
                <TextField
                    required
                    fullWidth
                    margin={"none"}
                    label={getLocalizedString("reference")}
                    value={formData.reference}
                    onChange={(e) => setFormValue(e.target.value, "reference")}
                    inputProps={{ maxLength: 250 }}
                />
            </Grid>
            <Grid container item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                    <InputLabel required id={`label-mode`}>
                        {formData.status === 'E' ? getLocalizedString("feedbackHowSent") : getLocalizedString("feedbackHowReceived")}
                    </InputLabel>
                    <Select
                        value={formData.mode}
                        labelId={`label-mode`}
                        id={`select-mode`}
                        onChange={(e) => setFormValue(e.target.value, "mode")}
                        margin={"none"}
                    >
                        {
                            modeList?.map((item) => (
                                <MenuItem
                                    className={"whiteText"}
                                    key={item.key}
                                    value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    )
}

export default FeedbackInputs;